// @flow

//
// React
//
import React from 'react';

//
// React Router
//
import { useNavigate, useLocation } from "react-router-dom";

//
// Redux Fantasy
//
import {
    useLocalSelector,
} from '../../../../../lib/redux-fantasy-reducers';

//
// Formatter
//
import {
    fmtDate,
    fmtTime,
    fmtMoney,
    fmtDocumentNumber
} from '../../../../../lib/trix-web-data-commons';

//
// Material UI
//
import { makeStyles } from '@mui/styles';

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import PaymentIcon from "@mui/icons-material/Payment";

//
// Styles
//
const useStyles = makeStyles(theme => ({
    root: {
    },
}));

//
// Props
//
type Props = {
    //
    // Hal forms template
    //
    __halFormsTemplate: any,

    //
    // Ducks
    //
    __ducks: {
        selectors: any,
        actions: any,
    },

    //
    // Container
    //
    container: any,

    //
    // Data
    //
    data: any,

    //
    // Callbacks
    //
    onClose: () => void,
} // End of Props

//
// Component
//
const RetailSaleHeaderForm = (props: Props): any => {
    //
    // Hooks
    //
    const navigate = useNavigate();
    const { search } = useLocation();
    // End hooks

    return(
        <>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: 2,
                paddingLeft: 2,
                paddingRight: 2,
            }}
        >
            <Stack>
                <Typography variant='h6' display='block'>
                    {fmtDocumentNumber(props.data.documentNo)}
                </Typography>
                <Typography variant='subtitle2' display='block'>
                    {fmtDate(props.data.documentDate)}
                </Typography>
                <Typography variant='subtitle2' display='block'>
                    {fmtTime(props.data.documentDate)}
                </Typography>
            </Stack>

            <Box 
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-end',
                }}
            >
                <Typography 
                    variant='h6' 
                    color='text.primary'
                    sx={{ fontWeight: 700 }}
                >
                    {fmtMoney(props.data.stockTotalAmount)}
                </Typography>
            </Box>
        </Box>

        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: 2,
                paddingLeft: 2,
                paddingRight: 2,
            }}
        >
            <Box sx={{ flexGrow: 1 }}>
                <Typography 
                    variant='caption'
                    sx={{ 
                        fontWeight: 600,
                        paddingTop: 1,
                    }}
                >
                    {(props.data && props.data.auditMetaData) ? props.data.auditMetaData.createdBy : ''}
                </Typography>
            </Box>

            {(props.data.stockTotalAmount && props.data.stockTotalAmount.amount > 0) ? 
                (
                    <Button
                        variant='contained'
                        color='success'
                        startIcon={<PaymentIcon />}
                        // disabled={!(props.data.stockTotalAmount && props.data.stockTotalAmount.amount > 0)}
                        onClick={() => {
                            navigate({ pathname: 'pay', search });
                        }}
                    >
                        Плати
                    </Button>
                ) : null
            }
        </Box>

        </>
    );
};
export default RetailSaleHeaderForm;